// extracted by mini-css-extract-plugin
export default {"content":"style_content__jnWIt","checkbox":"style_checkbox__+dkzQ"};